export class Brand {
  id: number;
  name: string;
  shortName: string;
  brandHeroImg: string;
  logo: string;
  website: string;
}
